import React from "react";
import AvailableToggle from "./AvailableToggle";
import IsgstToggle from "./IsgstToggle";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import "./menu.css";

const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

export default function MenuTable({
  rows = [],
  onToggleAvailable = () => {},
  onGstToggleAvailable = () => {},
  onEdit = () => {},
  onDelete = () => {},
  isBusy = false,
}) {
  return (
    <div className="card">
      <div className="table-wrap">
        <table className="tbl">
          <thead>
            <tr>
              <th>Item Id</th>
              <th>Item Name</th>
              <th>Price</th>
              <th>Available</th>
              <th>GST</th>
              <th>Category</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={7} className="empty-cell">
                  No menu items found
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.item_id}>
                  <td>{r.item_id}</td>
                  <td className="text-strong">{r.item_name}</td>
                  <td className="price">
                    {typeof r.price === "number" ? inr.format(r.price) : "—"}
                  </td>

                  <td className="avail">
                    <AvailableToggle
                      checked={!!r.availValue}
                      onChange={(next) => {
                        console.log("toggle fired:", next);
                        onToggleAvailable(r.uid, next);
                      }}
                      disabled={isBusy}
                    />
                  </td>

                  <td className="avail">
                    <IsgstToggle
                      checked={!!r.gstValue}
                      onChange={(next) => onGstToggleAvailable(r.uid, next)}
                      disabled={isBusy}
                    />
                  </td>

                  <td>{r.category || "-"}</td>

                  <td className="actions">
                    <div className="edit-delete">
                      <button
                        className="btn btn-light btn-icon"
                        onClick={() => onEdit(r.item_id)}
                        disabled={isBusy}
                      >
                        <FiEdit2 />
                      </button>
                      <button
                        className="btn btn-light btn-icon"
                        onClick={() => onDelete(r.item_id)}
                        disabled={isBusy}
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
